export default __webpack_public_path__ + "static/do-5cd644eecb37da649906b245185066fc.svg";